module.exports = __webpack_public_path__ + "static/media/arrow-right.bf3ba950.svg";